import Vue from "vue";
import { AclInstaller, AclCreate, AclRule } from "vue-acl";
import router from "@/router";
import store from "@/store/store";

Vue.use(AclInstaller);

let initialRole = "guest";
let ruleAdmin = new AclRule("admin");
let ruleMember = new AclRule("member");
let ruleGuest = new AclRule("guest");
let rulePublic = new AclRule("*");

export default new AclCreate({
	initial: initialRole,
	notfound: "/pages/login",
	router,
	acceptLocalRules: true,
	globalRules: {
		admin: ruleAdmin,
		member: ruleMember.or("admin"),
		guest: ruleGuest,
		"*": rulePublic
	},
	middleware: async acl => {
		if (store.state.auth.isUserLoggedIn() && store.state.auth.userPermissions === null) {
			try {
				await store.dispatch("auth/fetchUserPermissions", {});
			} catch (e) {
				console.log(e);
			}
		}

		let userInfo = JSON.parse(localStorage.getItem("userInfo"));
		if (userInfo && userInfo.existed_role) {
			acl.change("member");
		} else {
			acl.change("guest");
		}
	}
});
